<template>
  <div>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane
        v-for="dep in item.receive_dep_des"
        :key="dep.dep_id"
        :label="dep.dep_name"
        :name="dep.dep_id"
      >
        <template v-if="dep.dep_id == activeName">
          <DepSet
            ref="depSet"
            :item="item"
            :dep="dep.dep_id"
            @callback="callback"
          />
          <List
            @callback="callback"
            ref="list"
            :item="item"
            :dep="dep.dep_id"
          />
        </template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import DepSet from "./DepSet";
import List from "./List";

export default {
  components: {
    DepSet,
    List,
  },
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      activeName: this.item.receive_dep_des[0].dep_id,
    };
  },
  methods: {
    callback() {
      this.$refs["depSet"].getList();
      this.$refs["list"].getList();
    },
  },
};
</script>

<style>
</style>